import React, { useState } from 'react';
import { Loader2, Lock, ChevronRight, AlertCircle, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';
import { auth } from '../../lib/api';

export function AuthLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setLoginError(false);
    
    // Better Auth. A sessão volta como cookie httpOnly assinado pelo servidor —
    // não como string em localStorage, que era forjável pelo console.
    const { error } = await auth.signIn.email({ email, password });

    if (error) {
      console.error(error);
      setLoginError(true);
      toast.error(
        error.status === 429
          ? 'Muitas tentativas. Espere um minuto e tente de novo.'
          : 'Credenciais inválidas ou usuário desativado.',
      );
    } else {
      toast.success('Acesso liberado.');
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4 font-sans">
      <div className="bg-[#0A0A0A] max-w-md w-full rounded-2xl shadow-2xl border border-white/5 overflow-hidden relative">
        
        {/* Botão de fuga para voltar a Landing */}
        <button 
            onClick={() => window.location.hash = ''} 
            className="absolute top-4 left-4 text-xs font-bold uppercase tracking-widest text-neutral-600 hover:text-white transition-colors flex items-center gap-1 z-10"
        >
          <ChevronRight size={14} className="rotate-180" /> Voltar
        </button>

        <div className="p-8 text-center border-b border-white/5 mt-8 relative">
            <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mx-auto mb-4 shadow-[0_0_20px_rgba(255,255,255,0.1)]">
              <Lock size={24} className="text-black" />
            </div>
            <h1 className="text-xl font-bold text-white tracking-tight uppercase">NYROH CORE</h1>
            <p className="text-neutral-500 text-sm mt-1">Acesso operacional restrito</p>
        </div>
        
        <div className="p-8">
          <form onSubmit={handleLogin} className="space-y-5">
              <div>
                <label className="block text-xs font-bold tracking-widest uppercase text-neutral-400 mb-2">E-mail Corporativo</label>
                <input 
                  type="email" 
                  required
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  className={`w-full px-4 py-3 bg-black rounded-xl border outline-none transition-all text-white font-mono text-sm ${loginError ? 'border-red-500/50 focus:border-red-500' : 'border-white/10 focus:border-white/30'}`} 
                  placeholder="voce@empresa.com" 
                  autoFocus 
                />
              </div>
              <div>
                <label className="block text-xs font-bold tracking-widest uppercase text-neutral-400 mb-2">Chave de Acesso</label>
                <input 
                  type="password" 
                  required
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  className={`w-full px-4 py-3 bg-black rounded-xl border outline-none transition-all text-white font-mono text-sm ${loginError ? 'border-red-500/50 focus:border-red-500' : 'border-white/10 focus:border-white/30'}`} 
                  placeholder="••••••••" 
                />
                {loginError && (
                  <p className="text-xs text-red-500 mt-3 flex items-center gap-1 font-bold animate-in fade-in">
                    <AlertCircle size={14} /> Credenciais Inválidas ou bloqueadas.
                  </p>
                )}
              </div>
              <button 
                type="submit" 
                disabled={loading}
                className="w-full bg-white hover:bg-neutral-200 text-black font-bold py-3.5 rounded-xl transition-all flex items-center justify-center gap-2 tracking-wide uppercase text-sm mt-4 disabled:opacity-50"
              >
                {loading ? <Loader2 size={16} className="animate-spin" /> : 'Autenticar'} 
                {!loading && <ArrowRight size={16} />}
              </button>
          </form>
        </div>
      </div>
    </div>
  );
}
